export const MILESTONE_STATUSES: Record<string, common.MilestoneStatus> = {
  inProgress: 'In Progress',
  complete: 'complete',
  incomplete: 'incomplete',
};
